import { constants } from "redux/constants/redux-constants";

export const patientObject = (task) => ({
  type: constants.PATIENTS?.PATIENT_OBJECT,
  payload: task,
});
